import * as actionTypes from '../constants/actionType';
import initialState from './initialState';
import * as helpers from "../helpers";

export default function mNewsletterReducer(state = initialState.mNewsletter, action) {
  switch (action.type) {
    case actionTypes.MNEWSLETTER_LOAD_START:
      return helpers.updateOrAdd(state, {
        id: action.id,
        isLoading: true
      });

    case actionTypes.MNEWSLETTER_LOAD_FAIL:
      return helpers.updateOrAdd(state, {
        id: action.id,
        isLoading: false,
        error: action.error
      });

    case actionTypes.MNEWSLETTER_LOAD_SUCCESS: {
      return helpers.updateOrAdd(state, {
        ...action.data,
        isLoading: false,
        error: undefined
      });
    }

    case actionTypes.MNEWSLETTER_POST_START: {
      return {
        ...state,
        isLoading: true
      }
    }

    case actionTypes.MNEWSLETTER_POST_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case actionTypes.MNEWSLETTER_POST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ...action.data
      }
    }

    default:
      return state;
  }
}
